export default __webpack_public_path__ + "static/media/LAS0060.34I-30429_-17568_0.69c959a0.jpg";